import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {StockTakeBarcodeComponent} from '../stock-take-barcode/stock-take-barcode.component';
import {AlertController, ModalController} from '@ionic/angular';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {StockTakeProductsManualComponent} from '../stock-take-products-manual/stock-take-products-manual.component';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {PicturesPermissionService} from '../../services/pictures-permission.service';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../definitions/barcode-options';
import {ScanBarcodeService} from '../../services/scan-barcode.service';
import {GeneralService} from '../../services/general.service';
import {DocumentFromLiveDetailLineService} from '../../services/document-from-live-detail-line.service';
import {StockTakeHelperService} from '../../services/stock-take-helper.service';

@Component({
    selector: 'app-stock-take-detail',
    templateUrl: './stock-take-detail.component.html',
    styleUrls: ['./stock-take-detail.component.scss'],
})
export class StockTakeDetailComponent implements OnInit {
    @Input() stockCount: DocumentModel;
    stockCountTemp: DocumentModel;
    queryText: string;

    constructor(public modalController: ModalController,
                private stateManager: StateManagerService,
                private collectionNames: CollectionsNames,
                private alertController: AlertController,
                private picturesPermission: PicturesPermissionService,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private scanBarcodeService: ScanBarcodeService,
                private generalService: GeneralService,
                private stockTakeHelper: StockTakeHelperService) {
    }

    ngOnInit() {
        this.stockCountTemp = JSON.parse(JSON.stringify(this.stockCount));
    }

    async scanItem() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {

            console.log(barcode.text);
            
            // check if we scanned an EAN13 barcode , but are 
            // barcode length is 12 digits , it means its stripped a leading 
            // zero , we must add it back in


            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // TODO: Add PWA back
        // const modal = await this.modalController.create({
        //     component: null,
        //     backdropDismiss: false,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {
        //         document: this.documentTemp,
        //         reconciliation: true
        //     }
        // });
        // modal.onDidDismiss().then(() => {
        // });
        // return await modal.present();
    }

    async handleScanResult(barcode) {
        console.log('Scan Result');
        console.log(barcode);
        var stockLine = this.scanBarcodeService.findProductWithBarcode(barcode) as DetaillineDTOModel;

        if (stockLine) {
            this.confirmEquipment(JSON.parse(JSON.stringify(stockLine)));
        } else {

            
            stockLine = this.scanBarcodeService.findProductWithBarcode( '0' + barcode ) as DetaillineDTOModel;
            if(stockLine && stockLine.length > 10 ){
                this.confirmEquipment(JSON.parse(JSON.stringify(stockLine)));
            }else{
                await this.generalService.createToast('No match with barcode: ' + barcode);
                if (barcode) {
                    this.scanItem();
                }
            }
            
        }
    }

    async confirmEquipment(product) {
        const alert = await this.alertController.create({
            header: 'Equipment found: ' + product.description,
            message: 'Please inform quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'qty',
                    type: 'number',
                    placeholder: 'Quantity'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        this.scanItem();
                    }
                }, {
                    text: 'Yes',
                    handler: data => {
                        console.log(data.qty);
                        this.stockTakeHelper.addItemToStockCount(this.stockCountTemp, product, data.qty);
                        this.scanItem();
                    }
                }
            ]
        });
        await alert.present();
    }

    async addItem() {
        const modal = await this.modalController.create({
            component: StockTakeProductsManualComponent,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                stockCount: this.stockCountTemp
            }
        });
        modal.onDidDismiss().then(() => {
        });
        return await modal.present();
    }

    saveStockCount() {
        console.log(this.stockCountTemp);
        this.stateManager.upsert(this.collectionNames.STOCKCOUNTS, '$loki', JSON.parse(JSON.stringify(this.stockCountTemp)));
        this.stateManager.saveDatabase();
        this.modalController.dismiss();
    }

    async cancelStockCount() {
        if (this.stockCount === this.stockCountTemp) {
            this.modalController.dismiss();
        } else {

            const alert = await this.alertController.create({
                message: 'Do you want to cancel the stock count?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        }
    }

    async editQty(line: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'Edit Quantity',
            message: 'Please inform new quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'qty',
                    type: 'number',
                    placeholder: 'Quantity'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        line.qty = data.qty;
                    }
                }
            ]
        });
        await alert.present();
    }
}
